import { IconAction } from './Action';
import { IconAnimation } from './Animation';
import { IconArrow } from './Arrow';
import { IconChevron } from './Chevron';
import { IconCircle } from './Circle';
import { IconMisc } from './Misc';
import { IconTransfer } from './Transfer';
const IconList = {
    ...IconMisc,
    ...IconChevron,
    ...IconArrow,
    ...IconAction,
    ...IconCircle,
    ...IconAnimation,
    Transfer: IconTransfer,
};
export const Icon = IconList;
//# sourceMappingURL=index.js.map